import react, {useEffect} from 'react';
import api from "../../api";
import {Button, Col, Form, Input, InputNumber, message, Modal, Row} from "antd";
import {useNavigate} from "react-router-dom";
import './style.css'
import dayjs from "dayjs";
import React from "react";
import {useTranslations} from "../../lang";
import {CalendarOutlined, CheckOutlined, EnvironmentOutlined, SettingOutlined} from "@ant-design/icons";

export default function Gardens() {

    const [gardens, setGardens] = react.useState([])
    const [todos, setTodos] = react.useState({})
    const [newGardenForm] = Form.useForm()
    const [editGardenForm] = Form.useForm()
    const navigate = useNavigate()
    const [gardenSettingsModal, setGardenSettingsModal] = react.useState(false)
    const [editingGarden, setEditingGarden] = react.useState(null)
    const {translate} = useTranslations()

    function updateGarden() {
        const formData = editGardenForm.getFieldsValue()
        api.updateGarden(editingGarden.id, formData).then(() => {
            setGardenSettingsModal(false)
            loadGardens()
            message.success('De instellingen van je tuin zijn bijgewerkt!')
        })
    }

    function openGardenSettings(garden) {
        setGardenSettingsModal(true)
        setEditingGarden(garden)
        editGardenForm.setFieldsValue({
            name: garden.name,
            width: garden.width,
            length: garden.length
        })
    }

    function loadGardens() {
        api.gardens().then(setGardens)
    }

    useEffect(() => {
        api.gardens().then(setGardens)
    }, []);

    useEffect(() => {
        for (const garden of gardens) {
            api.getTasks({
                garden_id: garden.id,
                is_completed: false,
                end_date: dayjs().format("YYYY-MM-DD"),
            }).then((t) => {
                setTodos(prevTodos => ({
                    ...prevTodos,
                    [garden.id]: t
                }))
            })
        }
    }, [gardens]);

    async function createGarden() {
        try {
            const formData = await newGardenForm.validateFields()
            const garden = await api.createGarden(formData)
            navigate('/planner/' + garden.id)
        } catch (error) {
            if (!error?.errorFields) {
                // API errors are surfaced by the shared interceptor.
                return
            }
        }
    }

    const desktopCols = 12;
    const mobileCols = 24;




    function deleteGarden(garden) {
        Modal.confirm(({
            title: translate(`Weet je zeker dat je de tuin wilt verwijderen?`),
            content: translate("Dit kan niet ongedaan worden gemaakt!"),
            onOk: () => api.deleteGarden(garden.id).then(() => {
                loadGardens()
                message.success(translate('Tuin verwijderd!'))
                setGardenSettingsModal(false)
                editGardenForm.resetFields()
            })
        }))
    }

    return (
        <div>
            <h1>{translate('Tuinen')}</h1>
            <Modal
                open={gardenSettingsModal}
                cancelText={translate("Annuleren")}
                okText={translate("Opslaan")}
                onOk={() => updateGarden()}
                onCancel={() => {
                    setGardenSettingsModal(false)
                    editGardenForm.resetFields()
                }}
                footer={(
                    <Row>
                        <Col span={12} className={"text-left"}>
                            <Button danger onClick={() => deleteGarden(editingGarden)}>{translate('Tuin verwijderen')}</Button>
                        </Col>
                        <Col span={12} className={"text-right"}>
                            <Button onClick={() => setGardenSettingsModal(false)}
                                    className={"mar-r-1"}>{translate('Annuleren')}</Button>
                            <Button type={"primary"} onClick={() => updateGarden()}>{translate('Opslaan')}</Button>
                        </Col>
                    </Row>
                )}
            >
                <Form form={editGardenForm} layout={"vertical"} labelCol={24} wrapperCol={24}>
                    <Form.Item label={translate("Naam")} name={"name"}>
                        <Input placeholder={translate("Naam van de tuin")}/>
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label={translate("Breedte (meter)")} name={"width"}>
                                <InputNumber min={0} step={0.1} style={{width: '100%'}} placeholder="0"/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={translate("Lengte (meter)")} name={"length"}>
                                <InputNumber min={0} step={0.1} style={{width: '100%'}} placeholder="0"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
            <Row gutter={18}>
                {gardens.map(garden => (
                    <Col key={`garden` + garden.id} md={desktopCols} xs={mobileCols}>
                        <div className={"garden-box"}>
                            <Row>
                                <Col xs={20} md={18}><h2>{garden.name}</h2></Col>
                                <Col xs={4} md={0} className={"text-right"}>
                                    <Button onClick={() => openGardenSettings(garden)} size={"small"}>
                                        <SettingOutlined />
                                    </Button>
                                </Col>
                                <Col xs={0} md={6} className={"text-right"}>
                                    <Button onClick={() => openGardenSettings(garden)} size={"small"}>
                                        <SettingOutlined /> {translate('Tuin instellingen')}
                                    </Button>
                                </Col>
                            </Row>
                            <hr/>
                            <Row className={"mar-t-1"}>
                                <Col span={12}>
                                    <Button size={"small"} href={`/tasks?gardenId=${garden.id}`}><CheckOutlined /> Takenlijst</Button>
                                </Col>
                                <Col span={12} size={"small"} className={"text-right"}>
                                    <Button size={"small"} onClick={() => navigate('/map/' + garden.id)} className={"mar-r-1 hidden-mobile"}>
                                        <EnvironmentOutlined/> {translate('Kaart')}
                                    </Button>
                                    <Button type={"primary"} size={"small"} onClick={() => navigate('/planner/' + garden.id)}>
                                        <CalendarOutlined/> {translate('Planner')}
                                    </Button>
                                </Col>
                            </Row>

                            {todos[garden.id] && todos[garden.id].length > 0 && (
                                <div>
                                    <h3  className={"mar-t-1"}>{translate('Te doen')}</h3>
                                    <ul>
                                    {todos[garden.id].filter((t) => !t.is_completed && t.planting && t.planting.bed && t.planting.crop).map(task => (
                                        <li className={"todo-wrap"} key={`todo` + task.id}>
                                            {translate(task.title)} {task.planting.plants_per_row * task.planting.rows}x {task.planting.crop.name}  {task.planting.crop.is_direct_sown || task.planting.crop.is_seedling ? 'in' : 'voor' } bed {task.planting.bed.name}
                                        </li>
                                    ))}
                                    </ul>
                                </div>
                            )}

                            {(todos[garden.id] && todos[garden.id].length === 0) && (
                                <h3 className={"mar-t-1"}>{translate('Alles is gedaan')} 💪</h3>
                            )}


                        </div>
                    </Col>
                ))}
                <Col md={desktopCols} xs={mobileCols}>
                    <div className={"garden-box"}>
                        <h2>{translate('Nieuwe tuin')}</h2>
                        <Form form={newGardenForm} layout={"vertical"} labelCol={24} wrapperCol={24}>
                            <Form.Item
                                name={"name"}
                                rules={[{required: true, whitespace: true, message: translate('Vul een naam in')}]}>
                                <Input placeholder={translate("Naam van de tuin")}/>
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label={translate("Breedte (meter)")}
                                        name={"width"}
                                        rules={[
                                            {required: true, message: translate('Vul de breedte in')},
                                            {type: 'number', min: 0.01, message: translate('Breedte moet groter zijn dan 0')}
                                        ]}
                                    >
                                        <InputNumber min={0} step={0.1} style={{width: '100%'}} placeholder="0"/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={translate("Lengte (meter)")}
                                        name={"length"}
                                        rules={[
                                            {required: true, message: translate('Vul de lengte in')},
                                            {type: 'number', min: 0.01, message: translate('Lengte moet groter zijn dan 0')}
                                        ]}
                                    >
                                        <InputNumber min={0} step={0.1} style={{width: '100%'}} placeholder="0"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                <Button onClick={createGarden}>{translate('Toevoegen')}</Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
